import React from 'react';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { Hero } from './components/Hero';
import { TrustBadges } from './components/TrustBadges';
import { ProcessStrip } from './components/ProcessStrip';
import { ServicesPreview } from './components/ServicesPreview';
import { PricingPreview } from './components/PricingPreview';
import { Testimonials } from './components/Testimonials';
import { CoverageCallout } from './components/CoverageCallout';
import { StickyCTA } from './components/StickyCTA';
export function App() {
  return <div className="min-h-screen flex flex-col bg-white" data-id="element-0">
      <Header data-id="element-1" />
      <main className="flex-grow" data-id="element-2">
        <Hero data-id="element-3" />
        <TrustBadges data-id="element-4" />
        <ProcessStrip data-id="element-5" />
        <ServicesPreview data-id="element-6" />
        <PricingPreview data-id="element-7" />
        <Testimonials data-id="element-8" />
        <CoverageCallout data-id="element-9" />
      </main>
      <Footer data-id="element-10" />
      <StickyCTA data-id="element-11" />
    </div>;
}